<div id="staff_talk_wrap">
  <div id="picture" [ngClass]="{'picture1':picture===1,'picture305':picture===305,'picture315':picture===315,'picture325':picture===325,'picture335':picture===335,'picture2':picture!==1&&picture!==305&&picture!==315&&picture!==325&&picture!==335}">

  </div>
  <div id="talk" class="talk_item" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}" >
    {{talk}}
  </div>
</div>
<div id="test">萨科技打卡时间来得快上得快</div>



// WEBPACK FOOTER //
// ./src/app/staff-talk/staff-talk.component.html